import { messageOwnerType } from "../enums/messageOwnerType";
import boardType from "../enums/boardType";
import endPointsSections from "../store/models/endPointsSections";
import targetGroupType, { targetGroupTextType } from "../enums/targetGroupType";
import { gradesList } from "../enums/gradesEnum";
import toolLevelType from "../enums/toolLevelType";
import entitysType from "../enums/entitysType";


/* =========================
   CONSTANT FILTERS / SORTS
   ========================= */

export const teachingAssistantBotByDomain = (domain) => [
  { by: "type", value: entitysType.bot },
  { by: "domain", value: domain },
];

export const teachingAssistantBotByKey = (key) => [
  { by: "type", value: entitysType.bot },
  { by: "key", value: key },
];

export const usefulToolsFilters = [
  { by: "type", value: entitysType.usefulTool },
];

export const appletsFilters = [
  { by: "type", value: entitysType.applet },
];

export const appletsSort = [
  { by: "order", direction: "asc", nulls: "last", type: "number" },
];

export const appletsQuery = {
  filters: appletsFilters,
  sort: appletsSort,
};

export const usefulToolsDashboardFilters = [
  { by: "type", value: entitysType.usefulTool },
  { by: "tags", value: "dashboard" },
];
export const bgtDashboardCountersFilters = [
  { by: "type", value: "counter" },
  { by: "tags", value: "bgt" },
  { by: "tags", value: "dashboard" },
];

export const nmmBoardsFilters = [
  { by: "type", value: "board" },
  { by: "tags", value: "nmm" },
];
export const addedByEduToolsFilters = Object.freeze([
  { by: "type", value: entitysType.usefulTool },
  { by: "tags", value: "addedByEducation" },
]);

export const addedByGefenToolsFilters = Object.freeze([
  { by: "type", value: entitysType.usefulTool },
  { by: "tags", value: "addedByGefen" },
]);

export const addedByUserToolsFilters = Object.freeze([
  { by: "type", value: entitysType.usefulTool },
  { by: "tags", value: "addedByUser" },
]);

export const addedByUserToolsFiltersForSchool = (schoolId) => [
  
  { by: "type", value: entitysType.usefulTool },
  { by: "tags", value: "addedByUser" },
  { by: "schoolId", value: schoolId },
  { by: "toolLevel", value: toolLevelType.School },
];

export const personalToolsFilters = [
  { by: "type", value: entitysType.usefulTool },
  { by: "toolLevel", value: toolLevelType.Personal },
];

export const studyGroupToolsFilters = (studyGroupIdOrIds) => {
  const ids = (Array.isArray(studyGroupIdOrIds) ? studyGroupIdOrIds : [studyGroupIdOrIds]).filter(Boolean);
  const base = [
    { by: "type", value: entitysType.usefulTool },
    { by: "toolLevel", value: toolLevelType.StudyGroup },
  ];
  if (ids.length === 0)
    return base;
  return [
    ...base,
    {
      op: "OR",
      group: ids.map(id => ({ by: "studyGroupId", value: id })),
    },
  ];
};

export const schoolToolsFilters = (schoolId) => [
  { by: "type", value: entitysType.usefulTool },
  {
    op: "OR",
    group: [
      { by: "tags", value: "addedByGefen" },
      {
        group: [
          { by: "tags", value: "addedByUser" },
          { by: "toolLevel", value: toolLevelType.School },
          ...(schoolId ? [{ by: "schoolId", value: schoolId }] : []),
        ],
        op: "AND",
      },
    ],
  },
];

export const getSchoolToolsFilters = (isStudent, schoolId) => [
  { by: "type", value: entitysType.usefulTool },
  {
    op: "OR",
    group: [
      { by: "tags", value: "addedByGefen" },
      {
        group: [
          { by: "tags", value: "addedByUser" },
          { by: "toolLevel", value: toolLevelType.School },
          ...(schoolId ? [{ by: "schoolId", value: schoolId }] : []),
        ],
        op: "AND",
      },
    ],
  },
  { by: "visibleTo.isStudent", value: !isStudent, operator: "not_equals" },
];

export const basicToolsFilters = Object.freeze([
  { by: "type", value: entitysType.usefulTool },
  { by: "tags", value: "basicTools" },
]);

export const organizationalToolsFilters = Object.freeze([
  { by: "type", value: entitysType.usefulTool },
  {
    op: "OR",
    group: [
      { by: "tags", value: "basicTools" },
      { by: "tags", value: "addedByGefen" },
    ],
  },
]);

export const FinalProjectTools = [
  { by: "type", value: entitysType.usefulTool },
  {
    group: [
      { by: "tags", value: "finalProject" },
      { by: "tags", value: "dashboard" },
    ],
  },
];

export const ShortcutsFilter = [{ by: "type", value: "shortcut" }];

export const finalProjectCoursesFilters = [
  { by: "tags", value: "finalProject" },
  { by: "type", value: "course" },
  { by: "oldCourse", operator: "not_equals", value: true },
  { by: "tags", operator: "not_contains", value: "isInactive" },
];

export const bgtCoursesFilters = [
  { by: "providerName", value: "bgt" },
  { by: "type", value: "course" },
  { by: "oldCourse", operator: "not_equals", value: true },
  { by: "tags", operator: "not_contains", value: "isInactive" },
];

export const selfLearningFilter = [
  { by: "type", value: "course" },
  { by: "sections", value: endPointsSections.mySelfLearning },
  { by: "oldCourse", operator: "not_equals", value: true },
];

export const realisticIsraelFilters = [
  { by: "type", value: "course" },
  { by: "tags", value: "realisticIsrael" },
  { by: "oldCourse", operator: "not_equals", value: true },
  { by: "tags", operator: "not_contains", value: "isInactive" },
];

export const enrichmentFilters = (lang) => [
  { by: "category", value: "enriching" },
  { by: "type", value: "course" },
  { by: "languages", value: lang },
];

export const emergencyFiltersByLang = (lang) => [
  { by: "category", value: "emergencyLearning" },
  { by: "languages", value: lang },
  { by: "type", value: "course" },
];

export const courseToAssignFilters = [
  { by: "nmmId", operator: "not_exists" },
  { by: "tags", operator: "not_contains", value: "isInactive" },
  { by: "sections", value: endPointsSections.mySchoolCourses },
  { by: "type", value: "course" },
  { by: "oldCourse", operator: "not_equals", value: true },
];

export const coursesInActiveFilters = [
  { by: "tags", operator: "contains", value: "isInactive" },
  { by: "type", value: "course" },
  { by: "sections", value: endPointsSections.mySchoolCourses },
];

export const myCoursesFilter = [
  { by: "oldCourse", operator: "not_equals", value: true },
  { by: "sections", value: endPointsSections.mySchoolCourses },
  { by: "type", value: "course" },
  { by: "tags", operator: "not_contains", value: "isInactive" },
];

export const myCoursesFinalProject = [
  { by: "oldCourse", operator: "not_equals", value: true },
  { by: "sections", value: endPointsSections.mySchoolCourses },
  { by: "type", value: "course" },
  { by: "providerName", value: "shilovite" },
  { by: "tags", operator: "not_contains", value: "isInactive" },
];

export const oldCoursesFilters = [
  { by: "oldCourse", value: true },
  { by: "sections", value: endPointsSections.mySchoolCourses },
  { by: "tags", operator: "not_contains", value: "isInactive" },
  { by: "type", value: "course" },
];

export const oldCoursesF = [
  { by: "oldCourse", value: true },
  { by: "tags", operator: "not_contains", value: "isInactive" },
  { by: "type", value: "course" },
];

export const currentCoursesFilter = [
  { by: "type", value: "course" },
  { by: "oldCourse", value: undefined },
  { by: "tags", operator: "not_contains", value: "isInactive" },
];

export const studyGroupsFilter = [{ by: "type", value: "studyGroup" }];

export const studyGroupsWithDomainFilters = [
  { by: "type", value: "studyGroup" },
  { by: "domainName", operator: "exists" }, // אם יש לכם exists
];

export const entitiesByIdsFilter = (ids = [], type = "studyGroup") => [
  { by: "type", value: type },
  { by: "id", operator: "in", value: ids },
];

export const messagesByOwnerTypeFilters = [
  { by: "type", value: "message" },
  { by: "tags", value: "user" },
  { by: "ownerTypeId", value: messageOwnerType.admin },
];

export const messagesSort = [
  { by: "fromDate", direction: "desc", nulls: "last", type: "date" },
];

export const filterToolsForTeachers = (tools) => {
  return tools?.filter(t => t.visibleTo !== targetGroupTextType.Student);
}

export const filterToolsForStudents = (tools) => {
  return tools?.filter(t => t.visibleTo !== targetGroupTextType.Teacher);
}

export const messagesByStudyGroupsBoardQuery = (lang, studyGroupIds = [], boardId = 2) => ({
  filters: [
    { by: "type", value: "message" },
    { by: "tags", value: "user" },
    { by: "lang", operator: "in", value: [lang, ""] },
    { by: "boardId", value: boardId },
    { by: "nmmIds", operator: "in", value: studyGroupIds },
  ],
  sort: messagesSort,
});


/** Messages used as schedule placeholders (stub until dedicated API). Filter in UI by scheduleScope / nmmIds. */
export const scheduleBoardMessagesQuery = {
  filters: [
    { by: "type", value: "message" },
    { by: "tags", value: "user" },
    { by: "boardId", value: boardType.schedule},
  ],
  sort: messagesSort,
};

export const promotionsQuery = {
  filters: [
    { by: "type", value: "message" },
    { by: "boardId", value: boardType.promotion },
  ],
  sort: messagesSort,
};

export const messagesDashboardQuery = (lang, studyGroupIds = []) => {
  return {
    filters: [
      { by: "type", value: "message" },
      { by: "tags", value: "user" },
      { by: "lang", operator: "in", value: [lang, ""] },
      { by: "boardId", value: boardType.dashboardMessages },
      {
        op: "OR",
        group: [
          { by: "nmmIds", value: [] },
          { by: "nmmIds", operator: "in", value: studyGroupIds },
        ],
      },
    ],
    sort: messagesSort,
  };
};

export const messagesFilters = (lang) => [
  { by: "type", value: "message" },
  { by: "tags", value: "user" },
  { by: "lang", operator: "in", value: [lang, ""] },
];

export const messagesQuery = (lang) => ({
  filters: messagesFilters(lang),
  sort: messagesSort,
});

// export const messagesByOwnerTypeAndLangFilters = (lang) => [
//   { by: "type", value: "message" },
//   // { by: "ownerTypeId", value: 2 || 1 },
//   { by: "lang", value: lang },
// ];

// export const messagesByOwnerTypeAndLangQuery = (lang) => ({
//   filters: messagesByOwnerTypeAndLangFilters(lang),
//   sort: messagesSort,
// });

// assessments
export const assessmentsFilter = [
  { by: "type", value: "assessment" },
  { by: "isSubmitted", operator: "not_equals", value: true },
  {
    op: "OR",
    group: [
      { by: "dueDate", operator: "date_gte_now" },
      { by: "toDate", operator: "date_gte_now" },
    ],
  },
];

export const assessmentsSort = [
  { by: "dueDate", direction: "asc", nulls: "last", type: "date" },
];

export const assessmentsQuery = {
  filters: assessmentsFilter,
  sort: assessmentsSort,
};

// events
export const eventsFilter = [{ by: "type", value: "event" }];

export const eventsNotPassedFilter = [
  { by: "type", value: "event" },
  { operator: "event_not_passed" },
];

export const eventsSort = [
  { by: "date", direction: "asc", nulls: "last", type: "date" },
  { by: "from", direction: "asc", nulls: "last", type: "date" },
];

export const eventsNotPassedQuery = {
  filters: eventsNotPassedFilter,
  sort: eventsSort,
};

export const eventsQuery = {
  filters: eventsFilter,
  sort: eventsSort,
};

export const activeEventsQuery = {
  filters: [
    { by: "type", value: "event" },
    { operator: "event_active_now" },
  ],
  sort: [{ by: "from", direction: "asc", nulls: "last", type: "date" }],
};

export const oneActiveEventQuery = { ...activeEventsQuery };

export const galleryFilters = (domainName, lang) => [
  { by: "domains", value: domainName },
  { by: "providerName", value: ["moodle", "campus"] },
  { by: "category", operator: "not_equals", value: "enriching" },
  { by: "tags", value: "selfLearner" },
  { by: "languages", value: lang },
  { by: "type", value: "course" },
];

export const getDiscoveryBaseFilters = (studentkita) => [
  { by: "sections", operator: "not_contains", value: endPointsSections.mySchoolCourses },
  { by: "type", value: "course" },
  ...(studentkita != null && studentkita !== ""
    ? [{ operator: "student_grade", value: studentkita }]
    : []),
];

export const makpezaFilter = (lang) => [
  { by: "category", value: "makpeza" },
  { by: "languages", value: lang },
  { by: "type", value: "course" },
];

export const makpezaFiltersByDomain = (domainName, lang) => [
  { by: "domains", value: domainName },
  { by: "category", value: "makpeza" },
  { by: "languages", value: lang },
  { by: "type", value: "course" },
];

export const teacherGalleryFiltersByDomain = (domainName, lang) => [
  { by: "domains", value: domainName },
  { by: "tags", value: "teacherGallery" },
  { by: "languages", value: lang },
  { by: "type", value: "course" },
];

export const courseFiltersByNmmId = (studyGroupId) => [
  { by: "nmmId", value: studyGroupId },
  { by: "sections", value: endPointsSections.mySchoolCourses },
  { by: "type", value: "course" },
  { by: "oldCourse", operator: "not_equals", value: true },
  { by: "tags", operator: "not_contains", value: "isInactive" },
];

export const currentCoursesByDomainFilters = (domainName, nmmId, nmmDomains, nmmIds = null) => {
  const base = [
    { by: "type", value: "course" },
    { by: "sections", value: endPointsSections.mySchoolCourses },
    { by: "oldCourse", operator: "not_equals", value: true },
    { by: "tags", operator: "not_contains", value: "isInactive" }
  ];

  if (domainName === "general") {
    return [
      ...base,
      { by: "nmmId", operator: "not_exists" },
      {
        op: "OR",
        group: [
          { by: "domain", operator: "not_exists" },
          { by: "domain", operator: "not_in", value: nmmDomains },
        ],
      },
    ];
  }

  const hasNmmIds = (Array.isArray(nmmIds) && nmmIds.length > 0) || nmmId;

  if (hasNmmIds) {
    const nmmIdFilters = [];
    if (Array.isArray(nmmIds) && nmmIds.length > 0) {
      nmmIds.forEach(id => {
        if (id)
          nmmIdFilters.push({ by: "nmmId", value: id });
      });
    }
    else if (nmmId)
      nmmIdFilters.push({ by: "nmmId", value: nmmId });

    return [
      ...base,
      {
        op: "OR",
        group: [
          ...nmmIdFilters,
          {
            op: "AND",
            group: [
              { by: "nmmId", operator: "not_exists" },
              {
                op: "OR",
                group: [
                  { by: "domain", value: domainName },
                  { by: "domains", operator: "contains", value: domainName },
                ],
              },
            ],
          },
        ],
      },
    ];
  }
  else {
    return [
      ...base,
      { by: "nmmId", operator: "not_exists" },
      {
        op: "OR",
        group: [
          { by: "domain", value: domainName },
          { by: "domains", operator: "contains", value: domainName },
        ],
      },
    ];
  }
};

export const studyGroupsBySchoolIdFilters = (schoolId) => {
  if (!schoolId) return [];
  return [
    { by: "type", value: "studyGroup" },
    { by: "schoolId", value: Number(schoolId) },
  ];
};

export const studyGroupsByDomainFilters = (domainName) => {
  if (!domainName) return [];

  if (domainName === "general") {
    return [
      { by: "type", value: "studyGroup" },
      {
        op: "OR",
        group: [
          { by: "domainName", operator: "not_exists" },
          { by: "domainName", value: null },
          { by: "domainName", value: undefined },
        ],
      },
    ];
  }

  return [
    { by: "type", value: "studyGroup" },
    {
      op: "OR",
      group: [
        { by: "domainName", value: domainName },
        { by: "domains", operator: "contains", value: domainName }
      ],
    },
  ];
};

export const assessmentsByDomainQuery = (domainName, nmmDomains = []) => {
  const baseFilters = [
    { by: "type", value: "assessment" },
    { by: "isSubmitted", operator: "not_equals", value: true },
    {
      op: "OR",
      group: [
        { by: "dueDate", operator: "date_gte_now" },
        { by: "toDate", operator: "date_gte_now" },
      ],
    },
  ];

  let filters = baseFilters;

  if (domainName) {
    if (domainName === "general") {
      filters = [
        ...baseFilters,
        {
          op: "OR",
          group: [
            { by: "domain", operator: "not_exists" },
            { by: "domain", value: null },
            { by: "domain", operator: "not_in", value: nmmDomains },
          ],
        },
      ];
    } else {
      filters = [
        ...baseFilters,
        {
          op: "OR",
          group: [
            { by: "domain", value: domainName },
            { by: "domains", operator: "contains", value: domainName }
          ],
        },
      ];
    }
  }

  return { filters, sort: assessmentsSort };
};

export const eventsBySectionsFilters = (sections) => {
  const sectionsArr = Array.isArray(sections) ? sections : [sections];
  if (!sectionsArr?.length) return [{ by: "type", value: "event" }];

  return [
    { by: "type", value: "event" },
    {
      op: "OR",
      group: sectionsArr.map((s) => ({ by: "sections", value: s })), // includes any
    },
  ];
};

export const eventsByDomainFilters = (domainName, sectionNames = []) => {
  const sectionsArr = Array.isArray(sectionNames) ? sectionNames : [sectionNames];

  const base = [{ by: "type", value: "event" }];

  const domainFilter =
    domainName === "general"
      ? {
        op: "OR",
        group: [
          { by: "domain", operator: "not_exists" },
          { by: "domain", value: null },
        ],
      }
      : {
        op: "OR",
        group: [
          { by: "domain", value: domainName },
          { by: "domains", operator: "contains", value: domainName }
        ],
      };

  const sectionFilter =
    sectionsArr.length === 0
      ? []
      : [
        {
          op: "OR",
          group: sectionsArr.map((s) => ({ by: "sections", value: s })),
        },
      ];

  return [...base, domainFilter, ...sectionFilter];
};

export const eventsByDomainQuery = (domainName, sectionNames = []) => ({
  filters: eventsByDomainFilters(domainName, sectionNames),
  sort: eventsSort,
});

export const eventsBySectionsQuery = (sections, schoolId) => ({
  filters: [
    ...eventsBySectionsFilters(sections),
    ...(schoolId != null ? [{ operator: "calendar_assessment_school", value: schoolId }]: []),
  ],
  sort: eventsSort,
});

export const futureMoeMatriculationQuery = (domainName, sectionNames) => ({
  filters: [
    ...eventsByDomainFilters(domainName, sectionNames),
    { by: "providerName", value: "moecalendar" },
    { by: "date", operator: "date_gte_now" },
  ],
  sort: [{ by: "date", direction: "asc", nulls: "last", type: "date" }],
});

export const futureBgtMatriculationQuery = (domainName, sectionNames) => ({
  filters: [
    ...eventsByDomainFilters(domainName, sectionNames),
    { by: "providerName", value: "bgt" },
    { by: "date", operator: "date_gte_now" },
  ],
  sort: [{ by: "date", direction: "asc", nulls: "last", type: "date" }],
});

export const adminMessagesQuery = {
  filters: [
    { by: "type", value: "message" },
    { by: "tags", value: "school" },
    { by: "boardId", value: boardType.dashboardMessages },
  ],
  sort: messagesSort,
  dedup: { by: "id", prefer: { by: "lang", value: "he" } },
};

// Converts server messageFilters → UI fields (targetAudience + selectedGrades).
// Inverse of buildFilters in SystemMessagesEditorFlow.
export const parseMessageFilters = (messageFilters = []) => {
    if (!messageFilters?.length)
        return { targetAudience: null, selectedGrades: [] };

    if (messageFilters.some(f => f.targetGroupTypeId === targetGroupType.Everyone))
        return { targetAudience: targetGroupTextType.Everyone, selectedGrades: gradesList };

    const hasTeacher = messageFilters.some(f => f.targetGroupTypeId === targetGroupType.Teacher);
    const studentFilters = messageFilters.filter(f => f.targetGroupTypeId === targetGroupType.Student);
    const hasStudent = studentFilters.length > 0;

    let targetAudience = null;
    if (hasTeacher && hasStudent) targetAudience = targetGroupTextType.Everyone;
    else if (hasTeacher) targetAudience = targetGroupTextType.Teacher;
    else if (hasStudent) targetAudience = targetGroupTextType.Student;

    const allStudentsSelected = studentFilters.some(f => !f.grade);
    const selectedGrades = allStudentsSelected
        ? gradesList
        : gradesList.filter(g => studentFilters.some(f => f.grade === g.value));

    return { targetAudience, selectedGrades };
};
